<template>

    <FloatingPanel>

        <div class="canvas-blocks-sky-footerCharlie-BlockPanel">

            <CommonInputs :options="options"/>

            <SwitchInput label="Aantal kolommen tekst"
                         instruction="Kies het aantal kolommen dat aangemaakt word om tekst in te voeren"
                         :items="[
                             { value: 'one', label: 'Eén'},
                             { value: 'two', label: 'Twee'},
                             { value: 'three', label: 'Drie'},
                             { value: 'four', label: 'Vier'},
                         ]"
                         :options="options"
                         options-property="footer-column-count"/>

        </div>

    </FloatingPanel>

</template>

<script>

import AbstractPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel";
import FloatingPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel";
import CommonInputs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs";
import SwitchInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/SwitchInput";

export default {

    extends: AbstractPanel,

    components: {
        SwitchInput,
        FloatingPanel,
        CommonInputs,
    },
}

</script>

<style lang="scss" scoped>

.canvas-blocks-sky-footerCharlie-BlockPanel {

}

</style>
